import Store from './Store';
import has from 'lodash/has';

export default class SessionStorePlugin {
	static install (Vue, options) {
		Vue.localStore = Vue.prototype.$localStore = Store;
		Vue.mixin({
			props: {
				uid: {
					type: [null, String],
					default: null
				}
			},
			created () {
				if (this.$options.local && Array.isArray(this.$options.local)) {
					const getVariablePath = (item) => {
						let vm = this;
						const path = [];
						for (let i = 0; i < 15; i++) {
							(vm.$options.name || vm.$options._componentTag) &&
                            path.push(vm.$options.name || vm.$options._componentTag);
							(vm.$props.uid || vm.$options.uid) &&
                            path.push('(' + (vm.$props.uid || vm.$options.uid) + ')');
							if (has(vm, '$parent') && vm.$parent) vm = vm.$parent;
							else break;
						}
						return item + ':' + path.join('.');
					};
					for (const item of this.$options.local) {
						const propName = getVariablePath(item);
						if (has(this.$data, item)) {
							has(Store.$data, propName) &&
                            (this.$data[item] = Store.$data[propName]);
							this.$watch(item, {
								handler: (value, oldValue) => {
									Store.$data[propName] = value;
								},
								deep: true
							});
						}
					}
				}
			}
		});
	}
}
